import { getFormDefinition, createFormDataFromItem, createItemFromFormData } from './form';
import { entityToStore } from '@/utils/store';
import baseCrudMixin from '@/mixins/crud';
export default {
  computed: {
    definition() {
      return this.createDefinition();
    },
    entityStore() {
      return entityToStore(this.entity);
    }
  },
  mixins: [baseCrudMixin],
  data: () => ({
    entity: 'VatType',
    returnTo: 'VATTypes'
  }),
  created() {
    this.$store.dispatch('language/getItems');
  },
  methods: {
    getDependencies(data) {
      return [];
    },
    createDefinition() {
      return getFormDefinition(this);
    },
    formatVatTypeOption(value) {
      const option =
        value !== null && this.$store.getters['option/loadedOptions']('vatType').find(item => item.code === value);
      return option && option.description;
    },
    createFormDataFromItem,
    createItemFromFormData
  }
};
